import { Component, OnInit } from '@angular/core';
import {BsModalRef} from 'ngx-bootstrap';
import {ApiService} from '../../../../../../projects/accounting/src/public_api';

@Component({
  selector: 'app-point-purchase-detail',
  templateUrl: './point-purchase-detail.component.html',
  styleUrls: ['./point-purchase-detail.component.scss']
})
export class PointPurchaseDetailComponent implements OnInit {
  data = null;
  time:any = null;
  loading = false;

  constructor(
      public bsModal: BsModalRef,
      private api: ApiService
  ) { }

  ngOnInit() {
    this.load();
  }
  load(){

    this.loading = true;
    this.api.pointHistory(this.time).subscribe( rs => {
      this.loading = false;
      console.log(rs);
      if(rs && rs.succeed){
        rs.data = rs.data.filter( i => i.Bought > 0);
        rs.data.forEach( i => {
          i.Name = i.Subject[1];
          i.Phone = i.Subject[2];
          i.Address = i.Subject[3];
          i.Used = Math.abs(i.Used);
        });
          this.data  = rs.data;
      }
    })
  }
  close(){
    this.bsModal.hide()
  }
}
